const tooltips = document.querySelectorAll('.tooltip-text');

if(tooltips && tooltips.length > 0) {
  tooltips.forEach(function(tooltip) {
    if(window.innerWidth < 1024) {
      tooltip.addEventListener('click', function(e) {
        if(!tooltip.classList.contains('hover')) {
          tooltip.classList.add('hover');
        }
        else {
          tooltip.classList.remove('hover');
        }
      });
    }

    let distanceLeft = tooltip.getBoundingClientRect().left;
    let distanceRight = window.innerWidth - tooltip.getBoundingClientRect().right;
    let wordWidth = tooltip.getBoundingClientRect().width;
    let tooltipWidth = window.innerWidth < 1025 ? 250 : 300;
    
    if((distanceLeft + (wordWidth/2)) < (tooltipWidth / 2)) {
      tooltip.classList.add('set-left');
    }
    else if((distanceRight + (wordWidth/2)) < (tooltipWidth / 2)) {
      tooltip.classList.add('set-right');
    }
  });
  
  if(window.innerWidth < 1024) {
    window.addEventListener('click', function(e) {
      if (!e.target.closest('.tooltip-text') && (document.querySelectorAll('.tooltip-text.hover').length > 0)) {
        document.querySelectorAll(".tooltip-text.hover").forEach(function(tooltip) {
          tooltip.classList.remove('hover');
        });
      }
    });
  }

}